import { useEffect, useState } from "react";

import useReleaseUpdateDetector from "../../../hooks/useReleaseUpdateDetector";

export const RELEASE_UPDATE_SNOOZE_MS = 30 * 60 * 1000;

const UNSAVED_WORK_WARNING =
  "Refreshing will discard any unsaved work. If you have unsaved work, click Cancel, finish or save it, then update when you are ready.";

const ReleaseUpdateBanner = ({
  confirmFunction = message => window.confirm(message),
  nowFunction = Date.now,
  reloadFunction = () => window.location.reload(),
  snoozeMs = RELEASE_UPDATE_SNOOZE_MS,
  useUpdateDetector = useReleaseUpdateDetector,
}) => {
  const { latestBuild, updateAvailable } = useUpdateDetector();
  const [snoozedUntil, setSnoozedUntil] = useState(0);

  useEffect(() => {
    setSnoozedUntil(0);
  }, [latestBuild?.buildId]);

  useEffect(() => {
    const remaining = snoozedUntil - nowFunction();
    if (remaining <= 0) return undefined;

    const timeoutId = window.setTimeout(() => setSnoozedUntil(0), remaining);
    return () => window.clearTimeout(timeoutId);
  }, [nowFunction, snoozedUntil]);

  if (!updateAvailable || snoozedUntil > nowFunction()) return null;

  const updateNow = () => {
    if (confirmFunction(UNSAVED_WORK_WARNING)) {
      reloadFunction();
    }
  };

  return (
    <div
      className="border-b border-amber-300 bg-amber-50 px-3 py-3 text-amber-950 sm:px-6"
      role="status"
    >
      <div className="mx-auto flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="text-sm font-semibold">
            A new version is available
          </div>
          <div className="text-xs">
            Save or finish your current work before updating.
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-4 text-sm sm:shrink-0">
          <button
            className="font-medium text-amber-950 underline hover:no-underline"
            type="button"
            onClick={() => setSnoozedUntil(nowFunction() + snoozeMs)}
          >
            Later
          </button>
          <button
            className="rounded bg-amber-950 px-3 py-1.5 font-medium text-white hover:bg-amber-900"
            type="button"
            onClick={updateNow}
          >
            Update now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReleaseUpdateBanner;
